// Meaning interpretation engine (client-side, instant, no API).
// Turns free text into a structured problem map: core issue -> business
// domains (areas) -> inferred sub-themes. Biased to CRM/sales/creative/tech
// but broad and service-oriented. NOT literal keyword repetition.

const L = (en, pt) => ({ en, pt });

const DOMAINS = {
  crm: {
    area: "CRM",
    short: L("CRM", "CRM"),
    core: L("CRM effectiveness", "Eficácia do CRM"),
    triggers: ["salesforce", "hubspot", "pipedrive", "crm", "follow up", "follow-up", "data quality", "records", "cadastro", "base de dados"],
    branches: [L("adoption", "adoção"), L("pipeline visibility", "visibilidade do pipeline"), L("lead flow", "fluxo de leads"), L("follow-up gaps", "falhas de follow-up"), L("team usage", "uso pela equipe"), L("automation", "automação"), L("reporting", "relatórios"), L("data quality", "qualidade dos dados"), L("handoff", "passagem de bastão"), L("conversion", "conversão")],
  },
  sales: {
    area: "Sales",
    short: L("Sales", "Vendas"),
    core: L("Sales performance", "Desempenho de vendas"),
    triggers: ["sale", "sell", "vendas", "venda", "revenue", "receita", "quota", "deal", "negoci", "closing", "fechamento", "prospect", "sdr", "comercial"],
    branches: [L("pipeline", "pipeline"), L("qualification", "qualificação"), L("conversion", "conversão"), L("forecasting", "previsão"), L("outreach", "prospecção"), L("negotiation", "negociação"), L("enablement", "capacitação"), L("retention", "retenção"), L("upsell", "upsell"), L("closing", "fechamento")],
  },
  branding: {
    area: "Creative",
    short: L("Brand", "Marca"),
    core: L("Brand clarity", "Clareza de marca"),
    triggers: ["brand", "marca", "rebrand", "logo", "identity", "identidade", "positioning", "posicionamento", "perception", "percep", "reputation", "reputação"],
    branches: [L("brand perception", "percepção de marca"), L("positioning", "posicionamento"), L("message clarity", "clareza da mensagem"), L("tone", "tom"), L("audience", "público"), L("identity", "identidade"), L("differentiation", "diferenciação"), L("credibility", "credibilidade"), L("communication", "comunicação"), L("consistency", "consistência")],
  },
  website: {
    area: "Technology",
    short: L("Website", "Site"),
    core: L("Conversion & funnel", "Conversão e funil"),
    triggers: ["website", "site", "landing", "página", "pagina", "homepage", "web ", "conversion", "conversão", "funnel", "funil", "checkout", "ux", "user experience", "experiência do usuário"],
    branches: [L("website", "site"), L("conversion", "conversão"), L("message", "mensagem"), L("structure", "estrutura"), L("content", "conteúdo"), L("UX", "UX"), L("trust", "confiança"), L("call to action", "chamada para ação"), L("lead capture", "captura de leads"), L("sales funnel", "funil de vendas")],
  },
  marketing: {
    area: "Marketing",
    short: L("Marketing", "Marketing"),
    core: L("Demand & growth", "Demanda e crescimento"),
    triggers: ["marketing", "campaign", "campanha", "audience", "público", "publico", "lead generation", "lead gen", "awareness", "ads", "anúncio", "anuncio", "tráfego", "trafego", "seo", "inbound"],
    branches: [L("audience", "público"), L("channels", "canais"), L("content", "conteúdo"), L("campaigns", "campanhas"), L("messaging", "mensagem"), L("lead generation", "geração de leads"), L("awareness", "reconhecimento"), L("engagement", "engajamento"), L("funnel", "funil"), L("metrics", "métricas")],
  },
  automation: {
    area: "Technology",
    short: L("Automation", "Automação"),
    core: L("Process & automation", "Processo e automação"),
    triggers: ["automat", "automação", "automacao", "workflow", "fluxo", "integrat", "integração", "integracao", "manual", "efficiency", "eficiência", "eficiencia", "ops", "operação", "operation", "process", "processo"],
    branches: [L("workflow", "fluxo de trabalho"), L("integrations", "integrações"), L("manual work", "trabalho manual"), L("efficiency", "eficiência"), L("data flow", "fluxo de dados"), L("tooling", "ferramentas"), L("operations", "operações"), L("scalability", "escalabilidade"), L("handoffs", "passagens"), L("reliability", "confiabilidade")],
  },
  communication: {
    area: "Marketing",
    short: L("Communication", "Comunicação"),
    core: L("Communication", "Comunicação"),
    triggers: ["communicat", "comunicação", "comunicacao", "messaging", "mensagem", "copy", "tone of voice", "tom de voz", "narrative", "narrativa", "storytelling", "discurso"],
    branches: [L("messaging", "mensagem"), L("clarity", "clareza"), L("narrative", "narrativa"), L("tone", "tom"), L("audience", "público"), L("channels", "canais"), L("consistency", "consistência"), L("storytelling", "storytelling"), L("positioning", "posicionamento"), L("trust", "confiança")],
  },
  creative: {
    area: "Creative",
    short: L("Creative", "Criação"),
    core: L("Creative direction", "Direção criativa"),
    triggers: ["creative", "criativo", "criação", "criacao", "design", "visual", "art direction", "direção de arte", "direcao de arte", "estética", "estetica"],
    branches: [L("concept", "conceito"), L("visual identity", "identidade visual"), L("art direction", "direção de arte"), L("craft", "acabamento"), L("consistency", "consistência"), L("experience", "experiência"), L("storytelling", "narrativa"), L("differentiation", "diferenciação"), L("tone", "tom"), L("execution", "execução")],
  },
  strategy: {
    area: "Business Development",
    short: L("Strategy", "Estratégia"),
    core: L("Strategy & positioning", "Estratégia e posicionamento"),
    triggers: ["strateg", "estratég", "estrateg", "roadmap", "growth", "crescimento", "vision", "visão", "visao", "scale", "escalar", "priorit", "prioridade", "plan", "plano"],
    branches: [L("positioning", "posicionamento"), L("market", "mercado"), L("differentiation", "diferenciação"), L("roadmap", "roadmap"), L("priorities", "prioridades"), L("growth", "crescimento"), L("focus", "foco"), L("value", "valor"), L("opportunity", "oportunidade"), L("execution", "execução")],
  },
  journey: {
    area: "Sales",
    short: L("Customer journey", "Jornada do cliente"),
    core: L("Customer journey", "Jornada do cliente"),
    triggers: ["customer", "cliente", "journey", "jornada", "onboarding", "retention", "retenção", "retencao", "churn", "experience", "experiência", "experiencia", "touchpoint", "satisfação", "satisfacao"],
    branches: [L("touchpoints", "pontos de contato"), L("onboarding", "onboarding"), L("retention", "retenção"), L("experience", "experiência"), L("conversion", "conversão"), L("follow-up", "follow-up"), L("satisfaction", "satisfação"), L("churn", "churn"), L("loyalty", "fidelização"), L("handoff", "passagem")],
  },
  product: {
    area: "Technology",
    short: L("Technology", "Tecnologia"),
    core: L("Product & technology", "Produto e tecnologia"),
    triggers: ["product", "produto", "platform", "plataforma", "app", "software", "sistema", "system", "build", "tech", "tecnologia", "integration", "api", "dados", "data"],
    branches: [L("platform", "plataforma"), L("build", "construção"), L("systems", "sistemas"), L("integration", "integração"), L("data", "dados"), L("scalability", "escalabilidade"), L("reliability", "confiabilidade"), L("roadmap", "roadmap"), L("UX", "UX"), L("delivery", "entrega")],
  },
  partnerships: {
    area: "Business Development",
    short: L("Opportunities", "Oportunidades"),
    core: L("Opportunities & connections", "Oportunidades e conexões"),
    triggers: ["partner", "parceria", "network", "rede", "connection", "conexão", "conexao", "alliance", "aliança", "alianca", "introdu", "oportunidade", "opportunity", "expansion", "expansão"],
    branches: [L("partnerships", "parcerias"), L("channels", "canais"), L("network", "rede"), L("deals", "negócios"), L("alliances", "alianças"), L("introductions", "apresentações"), L("expansion", "expansão"), L("growth", "crescimento"), L("positioning", "posicionamento"), L("value", "valor")],
  },
};

const DOMAIN_LIST = Object.entries(DOMAINS).map(([key, d]) => ({ key, ...d }));
const AREA_ORDER = ["Sales", "Marketing", "Creative", "Technology", "CRM", "Business Development"];

const GENERIC_CORE = L("Your challenge", "O seu desafio");
const FALLBACK_KEYS = ["strategy", "communication"];

function rankBranches(branches, t, lang) {
  return [...branches]
    .map((b, i) => {
      const tokens = [b.en, b.pt].join(" ").toLowerCase().split(/[\s/]+/).filter((w) => w.length > 3);
      const score = tokens.reduce((s, w) => (t.includes(w) ? s + 1 : s), 0);
      return { b, score, i };
    })
    .sort((a, b) => b.score - a.score || a.i - b.i)
    .map((x) => x.b);
}

export function readiness(text) {
  const s = (text || "").trim();
  const words = s.split(/\s+/).filter(Boolean).length;
  if (s.length < 12 || words < 3) return "short";
  if (s.length < 40 || words < 7) return "forming";
  return "ready";
}

export function interpret(text, lang, state) {
  const raw = text || "";
  const t = raw.toLowerCase();
  const empty = { core: null, areas: [], domains: [] };
  if (raw.trim().length < 8) return empty;

  const scored = DOMAIN_LIST
    .map((d) => ({ d, s: d.triggers.reduce((n, kw) => (t.includes(kw) ? n + 1 : n), 0) }))
    .filter((x) => x.s > 0)
    .sort((a, b) => b.s - a.s);

  let chosen;
  let genericCore = false;
  if (scored.length === 0) {
    if (readiness(raw) === "short") return { core: { label: GENERIC_CORE[lang] }, areas: [], domains: [] };
    chosen = FALLBACK_KEYS.map((k) => DOMAIN_LIST.find((d) => d.key === k));
    genericCore = true;
  } else {
    chosen = scored.slice(0, 3).map((x) => x.d);
    const maxS = scored[0].s;
    const strong = scored.filter((x) => x.s >= Math.max(1, maxS * 0.6));
    genericCore = strong.length >= 2 || chosen.length >= 3;
  }

  const core = { label: genericCore ? GENERIC_CORE[lang] : chosen[0].core[lang] };

  const st = state || readiness(raw);
  const branchCount = st === "ready" ? (chosen.length >= 3 ? 4 : chosen.length === 2 ? 5 : 7) : chosen.length >= 3 ? 2 : 3;

  const domains = chosen.map((d) => ({
    key: d.key,
    area: d.area,
    label: d.short[lang],
    coreLabel: d.core[lang],
    branches: rankBranches(d.branches, t, lang).slice(0, branchCount).map((b) => ({ label: b[lang] })),
  }));

  const areas = AREA_ORDER.filter((a) => chosen.some((d) => d.area === a));

  return { core, areas, domains };
}

// Adjacent opportunities (contextual, high-level) derived from detected domains.
const OPP_LIB = {
  crm: { en: ["Sales automation", "There may be an opportunity to reduce manual follow-up and make CRM usage consistent."], pt: ["Automação de vendas", "Pode haver uma oportunidade de reduzir o follow-up manual e tornar o uso do CRM consistente."] },
  sales: { en: ["Conversion & process", "The issue may sit between initial interest and the sales conversation."], pt: ["Conversão e processo", "Parte do problema pode estar entre o interesse inicial e a conversa de vendas."] },
  leadflow: { en: ["Lead prioritization", "There may be an opportunity to improve how leads are prioritized and followed up."], pt: ["Priorização de leads", "Pode haver uma oportunidade de melhorar como os leads são priorizados e atendidos."] },
  conversion: { en: ["Customer journey", "Some of the issue may live between initial interest and the decision moment."], pt: ["Jornada do cliente", "Parte do problema pode estar entre o interesse inicial e o momento da decisão."] },
  journey: { en: ["Retention & experience", "There may be value in the moments after the first purchase or contact."], pt: ["Retenção e experiência", "Pode haver valor nos momentos após a primeira compra ou contato."] },
  automation: { en: ["Process automation", "Repetitive steps may be quietly slowing the team down."], pt: ["Automação de processos", "Etapas repetitivas podem estar desacelerando a equipe silenciosamente."] },
  branding: { en: ["Positioning", "The problem may begin before the lead reaches the sales team."], pt: ["Posicionamento", "O problema pode começar antes de o lead chegar ao time de vendas."] },
  communication: { en: ["Message clarity", "How the offer is communicated may be shaping the results upstream."], pt: ["Clareza da mensagem", "Como a oferta é comunicada pode estar moldando os resultados lá na frente."] },
  creative: { en: ["Creative direction", "A sharper creative expression may lift how the work is perceived."], pt: ["Direção criativa", "Uma expressão criativa mais afiada pode elevar como o trabalho é percebido."] },
  website: { en: ["Digital experience", "The website may be filtering out good enquiries before they arrive."], pt: ["Experiência digital", "O site pode estar filtrando bons contatos antes que eles cheguem."] },
  marketing: { en: ["Demand & attribution", "It may be worth clarifying which channels actually drive results."], pt: ["Demanda e atribuição", "Pode valer a pena esclarecer quais canais realmente geram resultado."] },
  strategy: { en: ["Strategic focus", "Sharper priorities may unlock momentum across the business."], pt: ["Foco estratégico", "Prioridades mais claras podem destravar o ritmo do negócio."] },
  product: { en: ["Systems & data", "Connected systems may remove friction the team feels daily."], pt: ["Sistemas e dados", "Sistemas conectados podem remover atritos que a equipe sente todo dia."] },
  partnerships: { en: ["Growth & partnerships", "New connections may open commercial routes worth exploring."], pt: ["Crescimento e parcerias", "Novas conexões podem abrir rotas comerciais que valem explorar."] },
};

export function getOpportunities(interpretation, lang) {
  if (!interpretation || !interpretation.domains) return [];
  const seen = new Set();
  const out = [];
  for (const d of interpretation.domains) {
    const o = OPP_LIB[d.key];
    if (o && !seen.has(d.key)) {
      seen.add(d.key);
      const [title, body] = o[lang] || o.en;
      out.push({ key: d.key, title, body });
    }
  }
  // ensure at least 3 with light generic fillers if needed
  const fillers = ["strategy", "communication", "journey"];
  for (const k of fillers) {
    if (out.length >= 5) break;
    if (!seen.has(k) && OPP_LIB[k]) {
      seen.add(k);
      const [title, body] = OPP_LIB[k][lang] || OPP_LIB[k].en;
      out.push({ key: k, title, body });
    }
  }
  return out.slice(0, 5);
}

// Information sufficiency state for the intake.
export function sufficiency(text, interpretation) {
  const r = readiness(text);
  const domains = (interpretation && interpretation.domains) ? interpretation.domains.length : 0;
  if (r === "short" || domains === 0) return "INSUFFICIENT";
  if (r === "forming" || domains < 2) return "DEVELOPING";
  return "SUFFICIENT";
}

export function detectLang(text, fallback = "en") {
  const s = (text || "").toLowerCase();
  if (!s.trim()) return fallback;
  if (/[ãõçáàâéêíóôú]/.test(s)) return "pt";
  const ptWords = ["você", "voce", "empresa", "preciso", "vendas", "marca", "não", "nao", "está", "esta", "nós", "nos ", "cliente", "negócio", "negocio", "também", "tambem", "quero", "fazer", "site", "gente"];
  const hits = ptWords.reduce((n, w) => (s.includes(w) ? n + 1 : n), 0);
  return hits >= 2 ? "pt" : fallback;
}
